import React from "react";

function TopButtons({ setQuery }) {
  const cities = [
    {
      id: 1,
      title: "London",
    },
    {
      id: 2,
      title: "Sydney",
    },
    {
      id: 3,
      title: "Tokyo",
    },
    {
      id: 4,
      title: "Toronto",
    },
    {
      id: 5,
      title: "Paris",
    },
  ];

  return (
    <div className="sm:flex sm:justify-around sm:my-2 sm:items-center md:flex md:justify-around md:my-2 md:items-center lg:flex lg:justify-around lg:my-2 lg:items-center  flex items-center justify-around my-2  ">
      {cities.map((city) => (
        <button
          key={city.id}
          className="text-white sm:text-lg md:text-lg lg:text-lg text-sm mx-3 font-medium transition ease-out hover:scale-125 "
          onClick={() => setQuery({ q: city.title })}
        >
          {city.title}
        </button>
      ))}
      
    </div>
  );
}

export default TopButtons;

// import React from 'react'

// function TopButtons() {
//     // #add more buttons
//     const cities=[
//         {
//             id:1,
//             title:'London'
//         },
//         {
//             id:2,
//             title:'Toronto'
//         },
//         {
//             id:3,
//             title:'Tokyo'
//         },
//         {
//             id:4,
//             title:'Sydney'
//         },
//         {
//             id:5,
//             title:'Paris'
//         },
//     ]
//   return (
//     <div className='flex items-center justify-around my-6'>
//         {cities.map((city)=>(
//         <button key={city.id} className='text-white text-lg font-medium transition ease-in hover:scale-110'>{city.title}</button>    
//         ))}
//     </div>
//   );
// }

// export default TopButtons;